import Card from "../../models/common/Card";
import iconOne from "../../assets/img/partnerProgram/fill_1.png";
import iconTwo from "../../assets/img/partnerProgram/fill_2.png";
import iconThird from "../../assets/img/partnerProgram/fill_3.png";
import iconFour from "../../assets/img/partnerProgram/fill_4.png";
import iconFive from "../../assets/img/partnerProgram/fill_5.png";
import iconsix from "../../assets/img/partnerProgram/fill_6.png";
import cardImage from "../../assets/img/partnerProgram/cardImage.png";
import cardImage2 from "../../assets/img/partnerProgram/cardImage2.png";
import cardImage3 from "../../assets/img/partnerProgram/cardImage3.png";
import endorsementProgram from "../../assets/file/endorsementProgram.pdf";
// Images
import partnerProgramLogo from "../../assets/img/partnerProgram/banner.png";
import appDeveloper from "../../assets/img/partnerProgram/app_developer.png";
import associate from "../../assets/img/partnerProgram/associate.png";
import professional from "../../assets/img/partnerProgram/professional.png";
import observability from "../../assets/img/partnerProgram/observability.png";
import serviceEndorsement from "../../assets/img/partnerProgram/serviceEndorsement.png";
import appDeveloperBadge from "../../assets/img/partnerProgram/appDeveloper4.png";
import dynatraceMigrationBadge from "../../assets/img/partnerProgram/dynatraceMigration.png";
import saasUpgradeBadge from "../../assets/img/partnerProgram/saasUpgrade.png";
const ENABLEMENT_PAGE = "https://partners.dynatrace.com/#/page/enablement";

// BANNER
export const TITLE = (
  <div>
    The Dynatrace Partner<br></br>Services Endorsement<br></br>Program
  </div>
);
export const SUB_TITLE = (
  <div>
    Build and grow Dynatrace services practices for your customers and<br></br>{" "}
    broaden your expertise with best practices and insights from our Dynatrace
    <br></br> ACE Services organization.
  </div>
);
export const BUTTON_NAME = "Apply now";
export const BUTTON_LINK = "https://dt-url.net/ux3wd9";
// --

// INTRODUCTION TEXT
export const INTRO_EYE_BROWN_HEADER = "HOW IT WORKS";
export const INTRO_TITLE = "Sales and technical enablement on your terms";
export const INTRO_TEXT = (
  <div>
    Like our platform certifications program, we’ll support you with platform
    and services training and enablement sessions as well as exam preparation.
    This will ensure you and your team(s) can achieve the competencies and
    expertise needed to successfully build and deliver Dynatrace Services
    Practices.
    <br></br>
    <br></br>
    After you complete the training modules and exam, you’ll be recognized and
    awarded with our Services Endorsement certification, which proves your deep
    understanding of Dynatrace ACE Services best practices. Once four or more
    individuals achieve their Services Certification within a region, your
    organization{" "}
    <a href="https://dt-url.net/ux3wd9" target="_blank">
      can then apply
    </a>{" "}
    to be recognized as a Services Endorsed partner.
  </div>
);
// --

// BENEFITS CARDS
export const EYE_BROWN_HEADER_CARDS = "WHY JOIN";
export const TITLE_CARDS = (
  <div>
    Modernize the cloud, <br></br> maximize your growth
  </div>
);
export const SUB_TITLE_CARDS = "Here's what's in it for you:";
const card1: Card = new Card(
  "Accelerate business growth",
  "Gain certification and know-how that ensures the Dynatrace Platform meets your customers’ business objectives, driving product adoption and long-term, strategic success.",
  iconOne
);
const card2: Card = new Card(
  "Marketing support",
  "Collaborate with our marketing teams on webinars, blogs, and marketing campaigns that amplify your exposure to prospective customers and new business opportunities.",
  iconTwo
);
const card3: Card = new Card(
  "Invites and access",
  "Join working groups, conferences, and other events that develop your relationships with existing customers and build new connections to strategic prospects.",
  iconThird
);
const card4: Card = new Card(
  "Product roadmap",
  "Gain an inside view into our product roadmap, so you can stay ahead of the latest industry trends and enhance observability and AIOps conversations with customers.",
  iconFour
);
const card5: Card = new Card(
  "Executive sponsorship",
  "Connect with Dynatrace executive sponsors that can help deliver a strategic edge and an insider’s view into emerging trends from Dynatrace.",
  iconFive
);
const card6: Card = new Card(
  "Earn recognition",
  "Through competency-specific badges that promote your status.",
  iconsix
);
const cardsFirstRow: Card[] = [card1, card2, card3];
const cardsSecondRow: Card[] = [card4, card5, card6];

export const ALL_CARD_ROWS: Record<number, Card[]> = {
  [0]: cardsFirstRow,
  [1]: cardsSecondRow,
};

// CONTENT BLOCKER
export const EYE_BROWN_HEADER = "WHAT’S INCLUDED";
export const CONTENT_BLOCKER_TITLE = "Topics that drive success with customers";
export const CONTENT_BLOCKER_SUB_TITLE =
  "Our program provides you with the methodologies and frameworks, best practices, and services-specific insights so you have the tools you need to validate, endorse, and successfully develop a practice with services delivery consultants.";
export const FRAME_QUOTE =
  "“Becoming Dynatrace Services Endorsed has allowed us to achieve tremendous growth with our customers. Through the delivery of Dynatrace’s observability and security solution, we have driven large-scale seven figure projects with customers yielding 7x services revenue for every dollar of Dynatrace consumed.”";
export const QUOTE_SIGN = "Martin Doornbusch";
export const QUOTE_JOB_TITLE =
  "Head of Digital Performance Management Operations, Eviden";

// --

// export const SERVICES_PROGRAM_CONTENT = [
//   {
//     title: "AppDeveloper",
//     link: "https://partners.dynatrace.com/#/page/app-developer",
//   },
//   {
//     title: "Saas Upgrade",
//     link: "https://partners.dynatrace.com/#/page/saas-migration",
//   },
//   {
//     title: "Dem & Business Analytics Specialist",
//     link: "https://partners.dynatrace.com/#/page/saas-migration",
//   },
//   {
//     title: "Advanced Security Specialist",
//     link: "https://partners.dynatrace.com/#/page/saas-migration",
//   },
//   {
//     title: "Advanced Observability Specialist",
//     link: "https://partners.dynatrace.com/#/page/saas-migration",
//   },
//   {
//     title: "Advanced Automation Specialist",
//     link: "https://partners.dynatrace.com/#/page/saas-migration",
//   },
// ];
export const SPECIALIZATION_BADGES = [
  {
    link: "https://university.dynatrace.com/certification/40373",
    icon: appDeveloperBadge,
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkOpenSamePage: false,
    linkForTitle: true,
  },
  {
    link: "https://university.dynatrace.com/certification/42509",
    icon: saasUpgradeBadge,
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkOpenSamePage: false,
    linkForTitle: true,
  },
  {
    link: "https://university.dynatrace.com/certification/47178",
    icon: "https://images.credly.com/images/2e31e70c-c0cc-4723-b5fc-42f33e021c11/image.png",
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkForTitle: true,
    linkOpenSamePage: false,
  },
  {
    link: " https://university.dynatrace.com/certification/47173",
    icon: "https://images.credly.com/images/aa688c9f-d319-4078-ba55-79665f2ad42f/image.png",
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkForTitle: true,
    linkOpenSamePage: false,
  },
  {
    link: "https://university.dynatrace.com/certification/47183",
    icon: "https://images.credly.com/images/d154c3c4-35b4-4293-96ee-3559e27c2e8d/image.png",
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkForTitle: true,
    linkOpenSamePage: false,
  },
  {
    link: "https://university.dynatrace.com/certification/47167",
    icon: "https://images.credly.com/images/4c071140-1761-4501-ae3b-2cfbf9db9295/image.png",
    eyebrow: "",
    title: "Learn more",
    subTitle: "",
    imageWidth: "100%",
    linkForTitle: true,
    linkOpenSamePage: false,
  },
];

// SIGN UP
export const SIGN_UP_TITLE =
  "Maximize skills. Modernize Clouds. Multiply sales.";
export const SIGN_UP_SUB_TITLE =
  "If you're already Professional Certified and ready to start the Services Program, head to Dynatrace University through the link below to get started.";
export const BANNER_LINK = "https://dt-url.net/dx23wt";
export const BUTTON_NAME_SIGN_UP = "Get started";
// --
